import { put, call, fork, takeEvery, all } from 'redux-saga/effects';

import * as notificationsModule from '../modules/notifications.module';
import * as Api from '../../core/api';

export function* fetchUnreadNotifications({ payload: { userId, limit } }) {
  const { response, error } = yield call(Api.notifications.fetchUnreadNotificationsForUser, { userId, limit });

  if (response) {
    yield put(notificationsModule.fetchUnreadNotificationsSuccess(response));
  } else {
    yield put(notificationsModule.fetchUnreadNotificationsFail(error));
  }
}

export function* watchFetchUnreadNotifications() {
  yield takeEvery(notificationsModule.fetchUnreadNotifications.getType(), fetchUnreadNotifications);
}

export function* markNotificationAsRead({ payload: { notificationId, userId, limit } }) {
  const { response, error } = yield call(Api.notifications.markNotificationAsRead, notificationId);

  if (response) {
    yield put(notificationsModule.markNotificationAsReadSuccess());
    yield put(notificationsModule.fetchUnreadNotifications({ userId, limit }));
  } else {
    yield put(notificationsModule.markNotificationAsReadFail(error));
  }
}

export function* watchMarkNotificationAsRead() {
  yield takeEvery(notificationsModule.markNotificationAsRead.getType(), markNotificationAsRead);
}

export default function* watchNotifications() {
  return yield all([
    fork(watchFetchUnreadNotifications),
    fork(watchMarkNotificationAsRead),
  ]);
}



/** WEBPACK FOOTER **
 ** ./js/redux/saga/notifications.saga.js
 **/